module.exports = __webpack_public_path__ + "SourceSansPro-Bold.e7e2b9eb656bd9670af3.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Bold.woff2
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Bold.woff2
// module chunks = styles